import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './breadcrumbs.component';
import { RouterModule } from '@angular/router';

@NgModule({
	declarations: [BreadcrumbsComponent],
	imports: [CommonModule, RouterModule],
	exports: [BreadcrumbsComponent]
})
export class WmBreadcrumbsModule {}
